import i18n from "../i18n";

export const displayNameByLocale = {
  en_EU: "En 🇪🇺",
  en_UK: "En 🇬🇧",
  en_IE: "En 🇮🇪",
  nb_NO: "Nb 🇳🇴",
  sv_SE: "Sv 🇸🇪",
  da_DK: "Da 🇩🇰",
  fi_FI: "Fi 🇫🇮",
  sv_FI: "Sv 🇫🇮",
  de_DE: "De 🇩🇪",
  es_ES: "Es 🇪🇸",
  fr_FR: "Fr 🇫🇷",
  nl_NL: "Nl 🇳🇱",
  pl_PL: "Pl 🇵🇱",
  ro_RO: "Ro 🇷🇴",
  it_IT: "It 🇮🇹",
  uk_UA: "Uk 🇺🇦",
  fr_BE: "Fr 🇧🇪",
  nl_BE: "Nl 🇧🇪",
  de_CH: "De 🇨🇭",
  fr_CH: "Fr 🇨🇭",
  de_AT: "De 🇦🇹",
  tr_TR: "Tr 🇹🇷",
  el_GR: "El 🇬🇷",
  cs_CZ: "Cs 🇨🇿",
  pt_PT: "Pt 🇵🇹",
  bg_BG: "Bg 🇧🇬",
  hr_HR: "Hr 🇭🇷",
  et_EE: "Et 🇪🇪",
  lt_LT: "Lt 🇱🇹",
  lv_LV: "Lv 🇱🇻",

  en_AU: "En 🇦🇺",
  en_CA: "En 🇨🇦",
  fr_CA: "Fr 🇨🇦",
  es_MX: "Es 🇲🇽",
}

export const emojiByCountry = {
  EU: "🇪🇺",
  UK: "🇬🇧",
  IE: "🇮🇪",
  NO: "🇳🇴",
  SE: "🇸🇪",
  DK: "🇩🇰",
  FI: "🇫🇮",
  DE: "🇩🇪",
  ES: "🇪🇸",
  FR: "🇫🇷",
  NL: "🇳🇱",
  PL: "🇵🇱",
  RO: "🇷🇴",
  IT: "🇮🇹",
  UA: "🇺🇦",
  BE: "🇧🇪",
  CH: "🇨🇭",
  AT: "🇦🇹",
  TR: "🇹🇷",
  GR: "🇬🇷",
  CZ: "🇨🇿",
  PT: "🇵🇹",
  BG: "🇧🇬",
  HR: "🇭🇷",
  EE: "🇪🇪",
  LT: "🇱🇹",
  LV: "🇱🇻",
  AU: "🇦🇺",
  CA: "🇨🇦",
  MX: "🇲🇽",
  US: "🇺🇸",
  FE: "🇺🇳"
}

export const countryNameByLocale = {
  en_EU: "Europe",
  en_UK: "UK",
  en_IE: "Ireland",
  nb_NO: "Norge",
  sv_SE: "Sverige",
  da_DK: "Danmark",
  fi_FI: "Suomi",
  sv_FI: "Finland",
  de_DE: "Deutschland",
  es_ES: "España",
  fr_FR: "France",
  nl_NL: "Nederland",
  pl_PL: "Polska",
  ro_RO: "România",
  it_IT: "Italia",
  uk_UA: "Україна",
  fr_BE: "Belgique",
  nl_BE: "België",
  de_CH: "Schweiz",
  fr_CH: "Suisse",
  de_AT: "Österreich",
  tr_TR: "Türkiye",
  el_GR: "Ελλάδα",
  cs_CZ: "Česko",
  pt_PT: "Portugal",
  bg_BG: "България",
  hr_HR: "Hrvatska",
  et_EE: "Eesti",
  lt_LT: "Latvija",
  lv_LV: "Lietuva",

  en_AU: "Australia",
  en_CA: "Canada",
  fr_CA: "Canada",
  es_MX: "México",

}

export const countryFromLocale = (locale: string) => {
  if (locale.length !== 5) {
    return "OT"
  }
  return locale.substring(3)
}

export const uiLanguages = ["en", "nb", "de", "es", "fr", "it", "ro", "fi"];

export const emojiFromLang = (lang: string) => {
  const langToEmoji = {
    en: "🇬🇧",
    nb: "🇳🇴",
    de: "🇩🇪",
    es: "🇪🇸",
    fr: "🇫🇷",
    it: "🇮🇹",
    ro: "🇷🇴",
    fi: "🇫🇮",
  };
  const emoji = langToEmoji[lang];
  return emoji || '🏳️';
}

export const displayStringFromLang = (lang: string) => {
  const t = i18n.t;
  const displayString = t('lang.' + lang);
  return displayString || lang
}

export const emojiFromLocale = (locale: string) => {
  const disp = displayNameByLocale[locale];
  if (!disp) {
    return '🏳️';
  }
  const tokens = disp.split(' ');
  if (tokens.length < 2) {
    return '🏳️';
  }
  return tokens[1];
}

export const displayStringFromCountry = (country: string) => {
  const t = i18n.t;
  const displayString = t('country.' + country.toLowerCase());
  return displayString || country;
}
